import React from 'react'
import {
  BooleanField, Datagrid, List, TextField, EditButton, SelectField, TopToolbar, SearchInput,
} from 'react-admin'
import { Button } from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import CustomPagination from '../../MyPagination'
import ExportModal from '../../components/ExportModal'
import ContactModal from '../../components/ContactModal'

const UsersList = (props) => {
  const [modalType, setModalType] = React.useState(null)
  const handleOpenClubModal = () => setModalType('users')
  const handleCloseClubModal = () => setModalType(null)

  const [contactModalOpened, setContactModalOpened] = React.useState(false)
  const handleOpenContactModal = () => setContactModalOpened(true)
  const handleCloseContactModal = () => setContactModalOpened(false)

  const UsersListActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      {/* Add your custom actions */}
      <Button startIcon={<ChatIcon />} color="primary" onClick={handleOpenContactModal}>
        Écrire à tous les joueurs
      </Button>
      <Button startIcon={<CloudDownloadIcon />} color="primary" onClick={handleOpenClubModal}>
        Exporter les utilisateurs
      </Button>
    </TopToolbar>
  )

  const postFilters = [<SearchInput source="qName" alwaysOn />]

  return (
    <>
      <List
        {...props}
        filters={postFilters}
        pagination={<CustomPagination />}
        bulkActionButtons={false}
        actions={<UsersListActions />}
        sort={{ field: 'lastname', order: 'DESC' }}
      >
        <Datagrid>
          <TextField source="idCrm" label="idCrm" />
          <TextField source="name" label="Prénom" />
          <TextField source="lastname" label="Nom" />
          <TextField source="licenceNumber" label="Numéro de licence" />
          <SelectField
            disabled
            label="Rôle"
            source="authority"
            allowEmpty="false"
            choices={[
              {
                id: 'admin',
                name: 'Administrateur',
              },
              {
                id: 'organiser',
                name: 'Organisateur',
              },
              {
                id: 'user',
                name: 'Utilisateur',
              },
            ]}
          />
          <BooleanField source="handicap" label="Joueur" />
          <TextField source="phone" label="Téléphone mobile" sortable={false} />
          <TextField source="email" label="Email" sortable={false} />
          <EditButton label="Éditer l'utilisateur" basePath="/users" />
        </Datagrid>
      </List>
      <ExportModal handleClose={handleCloseClubModal} type={modalType} />
      <ContactModal handleClose={handleCloseContactModal} open={contactModalOpened} receiver="PLAYERS" />
    </>
  )
}
export default UsersList
